'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: auto;\n  scroll-behavior: smooth;\n'], ['\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: auto;\n  scroll-behavior: smooth;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  width: ', 'px;\n  height: ', 'px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  transform-origin: left top;\n  transform: scale(', ', ', ');\n'], ['\n  position: relative;\n  width: ', 'px;\n  height: ', 'px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  transform-origin: left top;\n  transform: scale(', ', ', ');\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 20px;\n  height: 20px;\n  margin-left: -10px;\n  margin-top: -10px;\n  color: red;\n  z-index: 5000;\n'], ['\n  width: 20px;\n  height: 20px;\n  margin-left: -10px;\n  margin-top: -10px;\n  color: red;\n  z-index: 5000;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactResizeDetector = require('react-resize-detector');

var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);

var _iconLayer = require('./icon-layer');

var _iconLayer2 = _interopRequireDefault(_iconLayer);

var _imageLayer = require('./image-layer');

var _imageLayer2 = _interopRequireDefault(_imageLayer);

var _patternLayer = require('./pattern-layer');

var _patternLayer2 = _interopRequireDefault(_patternLayer);

var _scrollingLayer = require('./scrolling-layer');

var _scrollingLayer2 = _interopRequireDefault(_scrollingLayer);

var _animationLayer = require('./animation-layer');

var _animationLayer2 = _interopRequireDefault(_animationLayer);

var _parallaxLayer = require('./parallax-layer');

var _parallaxLayer2 = _interopRequireDefault(_parallaxLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Viewport = _styledComponents2.default.div(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.scale;
}, function (props) {
  return props.scale;
});
//(${props => (props.scale === 1.0) ? '' : `transform: scale(${props.scale}, ${props.scale});`}

var Center = _styledComponents2.default.div(_templateObject3);

/** @class Stage
 * A stage is the setting for a virtual expo,
 * composed of a background and foreground.
 * @prop {Array} layers - An array of objects describing the stage's layers
 * @prop {integer} width - the width of the stage in pixels
 * @prop {integer} height - the height of the stage in pixels
 * @prop {string} identifier - a unique identifier for the stage
 */

var Stage = function (_Component) {
  _inherits(Stage, _Component);

  /** @constructor
    * Creates a new stage instance.
    */
  function Stage(props) {
    _classCallCheck(this, Stage);

    var _this = _possibleConstructorReturn(this, (Stage.__proto__ || Object.getPrototypeOf(Stage)).call(this, props));

    _this.state = {
      scale: 1.0,
      center: { x: 0, y: 0 }
    };
    _this.scrollWatchers = [];
    _this.ticking = false;
    _this.requestTick = function () {
      if (!_this.ticking) requestAnimationFrame(_this.update);
      _this.ticking = true;
    };
    _this.update = function () {
      _this.setState({
        scrollDistance: _this.viewport.scrollLeft,
        scrollPercent: _this.viewport.scrollLeft / (_this.props.width - _this.state.vw)
      });
      _this.ticking = false;
    };
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handleScrollEvent = _this.handleScrollEvent.bind(_this);
    return _this;
  }

  _createClass(Stage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeyPress);
      this.viewport.addEventListener('scroll', this.handleScrollEvent);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyPress);
      this.viewport.removeEventListener('scroll', this.handleScrollEvent);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      if (newProps.identifier !== this.props.identifier) {
        this.viewport.scrollLeft = 0;
        this.viewport.scrolLTop = 0;
      }
    }
    /** @method handleResize
      * Scales the stage to fill the viewport, if needed.
      */

  }, {
    key: 'handleResize',
    value: function handleResize(width, height) {
      var _this2 = this;

      // Determine scaling factors
      var oldScale = this.state.scale.x;
      var scaleWidth = width / this.props.width;
      var scaleHeight = height / this.props.height;
      // Pick the largest
      var scale = scaleWidth > scaleHeight ? scaleWidth : scaleHeight;
      // Only scale up
      /*  if(scale < 1.0) {
          // Keep default scale
          this.setState({scale: 1.0, vw: width, vh: height}, () => {
            this.viewport.scrollLeft = (this.props.width - width) / 2;
            this.viewport.scrollTop = (this.props.height - height) / 2;
          });
        } else {*/
      // Apply calculated scale
      this.setState({ scale: scale, vw: width, vh: height }, function () {
        _this2.viewport.scrollLeft = (_this2.props.width * scale - width) / 2;
        _this2.viewport.scrollTop = (_this2.props.height * scale - height) / 2;
      });

      //}
    }
  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(event) {
      this.requestTick();
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          return this.handleScroll('left');
        case 'ArrowRight':
          event.preventDefault();
          return this.handleScroll('right');
        case 'ArrowUp':
          event.preventDefault();
          return this.handleScroll('up');
        case 'ArrowDown':
          event.preventDefault();
          return this.handleScroll('down');
      }
      switch (event.charCode || event.keyCode) {
        case 27:
          event.preventDefault();
          return this.handleScroll('left');
        case 26:
          event.preventDefault();
          return this.handleScroll('right');
        case 24:
          event.preventDefault();
          return this.handleScroll('up');
        case 25:
          event.preventDefault();
          return this.handleScroll('down');
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(direction) {
      switch (direction) {
        case 'left':
          if (this.viewport) this.viewport.scrollLeft = this.viewport.scrollLeft - this.state.vw / 2;
          break;
        case 'right':
          if (this.viewport) this.viewport.scrollLeft = this.viewport.scrollLeft + this.state.vw / 2;
          break;
        case 'up':
          if (this.viewport) this.viewport.scrollTop = this.viewport.scrollTop - this.state.vh / 2;
          break;
        case 'down':
          if (this.viewport) this.viewport.scrollTop = this.viewport.scrollTop + this.state.vh / 2;
          break;
      }
    }
    /** @method render()
      * Renders the stage
      */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var layers = this.props.layers.map(function (layer, index) {
        switch (layer.type) {
          case 'parallax':
            return _react2.default.createElement(_parallaxLayer2.default, _extends({ key: 'layer-' + index }, layer, { width: _this3.props.width, height: _this3.props.height, scrollDistance: _this3.state.scrollDistance }));
          case 'animation':
            return _react2.default.createElement(_animationLayer2.default, _extends({ key: 'layer-' + index }, layer, { width: _this3.props.width, height: _this3.props.height, showBorders: _this3.props.editorPreview }));
          case 'scroll':
            return _react2.default.createElement(_scrollingLayer2.default, _extends({ key: 'layer-' + index }, layer, { width: _this3.props.width, height: _this3.props.height, showBorders: _this3.props.editorPreview }));
          case 'pattern':
            return _react2.default.createElement(_patternLayer2.default, _extends({ key: 'layer-' + index }, layer, { width: _this3.props.width, height: _this3.props.height, showBorders: _this3.props.editorPreview }));
          case 'image':
            return _react2.default.createElement(_imageLayer2.default, _extends({ key: 'layer-' + index }, layer, { showBorders: _this3.props.editorPreview }));
          case 'icons':
            return _react2.default.createElement(_iconLayer2.default, _extends({ key: 'layer-' + index }, layer, { showBorders: _this3.props.editorPreview, width: _this3.props.width, height: _this3.props.height }));
          default:
            return null;
        }
      });
      return _react2.default.createElement(
        Viewport,
        { innerRef: function innerRef(vp) {
            return _this3.viewport = vp;
          } },
        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize }),
        _react2.default.createElement(
          Wrapper,
          _extends({ scale: this.state.scale }, this.props),
          layers,
          this.props.children,
          _react2.default.createElement(Center, { id: 'center' })
        )
      );
    }
  }]);

  return Stage;
}(_react.Component);

exports.default = Stage;


Stage.propTypes = {
  layers: _propTypes2.default.array.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  identifier: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/stage.js
// module id = 38
// module chunks = 0